export const apis = {
    //Community
    GET_COMMUNITY: 'api/getcommutiny',
    GET_COMMUNITY_BY_ID: 'api/getcommutinybyid/',
    GET_COMMUNITY_MOST_VISITED: 'api/most-visited',
};